import React from 'react';

const WideDialog = ({ isOpen, onClose, children, maxWidth = '7xl' }) => {
  if (!isOpen) return null;

  const maxWidthClasses = {
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    'full': 'max-w-full'
  };

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop with fade animation */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 transition-opacity animate-fade-in"
        onClick={onClose}
      />

      {/* Dialog positioning */}
      <div className="flex min-h-screen items-center justify-center p-4">
        {/* Dialog content with slide animation */}
        <div 
          className={`relative w-full ${maxWidthClasses[maxWidth] || 'max-w-7xl'} bg-white rounded-lg shadow-xl animate-slide-up`}
          onClick={(e) => e.stopPropagation()}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default WideDialog; 